module.exports = __webpack_public_path__ + "static/alarmex-10d8dea4447b1cdc07e598d0ac49d3e2.jpg";